import { createFileRoute } from "@tanstack/react-router";
import CadenasFranquicias from "@/pages/CadenasFranquicias";

export const Route = createFileRoute("/cadenas-y-franquicias")({ component: CadenasFranquicias });
